import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const painPoints = ['Comes menos pero sigues subiendo de peso', 'Haces cardio todos los días y no ves resultados', 'Te sientes cansada aunque duermas 8 horas', 'Tu ropa favorita ya no te queda igual', 'Tu médico te dice: "es la edad, es normal"'];
export function PainPointsSection() {
  return <section className="w-full bg-sage/10 py-16 md:py-24 px-4" data-id="element-93">
      <div className="max-w-5xl mx-auto" data-id="element-94">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl font-bold text-terracotta text-center mb-12" data-id="element-95">
          ¿Te suena familiar?
        </motion.h2>

        <div className="space-y-4 mb-12" data-id="element-96">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 rounded-lg shadow-md flex items-start gap-4" data-id="element-97">
              <CheckCircle2Icon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-98" />
              <p className="text-lg text-brown" data-id="element-99">{point}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-2xl font-semibold text-center text-brown italic" data-id="element-100">
          No es tu culpa. Te han dado las instrucciones equivocadas.
        </motion.p>
      </div>
    </section>;
}